<div class="container">
<h1>AI Search</h1>
<h3>(Experimental)</h3>
<p>Thanks for testing our new AI Search! It's still experimental and can make mistakes.</p>
<form (ngSubmit)="onSubmit()">
  <div class="m-3">
    <label for="prompt">What are you looking for?</label>
    <textarea id="prompt" class="form-control" [(ngModel)]="prompt" name="prompt" style="height: 100px" placeholder="Type something like 'I am looking for a hunting lease in Virginia'"></textarea>
    <button type="submit">Submit</button>
  </div>
  
</form>

<spinner *ngIf="loading" messageRelativePosition="bottom" message="Loading matching listings"> </spinner>
<div *ngIf="!loading" class="col d-flex justify-content-center">
    <hr />
    <div class="row justify-content-md-center" id="search-results">
        <new-search-result *ngFor="let listing of listings" [listing]="listing"></new-search-result>
    </div>
</div>
</div>